/* eslint-disable @typescript-eslint/ban-ts-comment, @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any */
/* tslint:disable */
// @ts-nocheck
// What's with all the above disables?
//  this is what a legacy 7 year old codebase looks like.
import { Grid } from '@elliemae/ds-grid';
import { __UNSAFE_SPACE_TO_DIMSUM, op, styled, useTheme } from '@elliemae/ds-system';
import { DSFullPageContainer, DSFullPageContainerScroll } from '../FullPageContainer/index.js';

const Body = styled(Grid)`
  margin: 0 auto;
  width: 100%;
  @media (min-width: ${({ theme }) => theme.breakpoints.small}) {
    ${({ theme }) => `width: ${op('*', __UNSAFE_SPACE_TO_DIMSUM(theme.space.xxl), 6.25)};`}
  }
`;

const PageForm = ({ header = null, body = null, footer = null }) => {
  const theme = useTheme();
  const rows = [1];
  if (header) rows.unshift(op('*', __UNSAFE_SPACE_TO_DIMSUM(theme.space.xxl), 1.125));
  if (footer) rows.push(theme.space.l);
  return (
    <DSFullPageContainer rows={rows}>
      {header && <Grid>{header}</Grid>}
      <Grid style={{ overflow: 'hidden' }}>
        <DSFullPageContainerScroll>
          <Body>{body}</Body>
        </DSFullPageContainerScroll>
      </Grid>
      {footer && <Grid>{footer}</Grid>}
    </DSFullPageContainer>
  );
};

const DSPageForm = PageForm;
const DSMobilePageForm = DSPageForm;

export { DSMobilePageForm, DSPageForm };
